<app-kontable
  [service]="srvCurrency"
  [paginationType]="paginationType"
  [title]="'currencyList.listTitle' | translate"
  [columns]="['id', 'iso_code', 'name', 'simbol', 'decimal']"
  [titles]="['ID', 'common.isoCode', 'common.name', 'common.simbol', 'common.decimal']"
  [showInfoButton]="false"
  [showGlobalFilter]="false"
  [showRecoverButton]="false"
  [showDetailsButton]="false"
  [showAddButton]="true"
  (onAdd)="showAddOrEditDialog(null)"
  (onEdit)="showAddOrEditDialog($event)"
  (onRemove)="deleteCurrency($event)"
  [(fireNewDataAvailable)]="newDataAvailable"
>
</app-kontable>

<p-dialog
*ngIf="addEditDialog"
header="{{modalTitle}}"
[(visible)]="addEditDialog"
[modal]="true"
[resizable]="false"
[draggable]="false"
[width]="500"
(onHide)="closeAddDialog()">
  <app-currency-form
    (currencyAdded)="currencyAdded($event)"
    (currencyUpdated)="currencyUpdated($event)"
    *ngIf="srvCurrency.currencyEditing"
    [dialogBoxCurrency]="srvCurrency.currencyEditing"
  ></app-currency-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/currencies/currencies.component.html